import { render, staticRenderFns } from "./CategoryMedia.vue?vue&type=template&id=48fa2826&"
import script from "./CategoryMedia.vue?vue&type=script&lang=ts&"
export * from "./CategoryMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports